import LegacyInterceptor from '../LegacyInterceptor'

const api = new LegacyInterceptor()

export default {
  getProcedimentos(tabelaId, porteId): any {
    return api.get(`/calculadora/procedimentos/tabela/${tabelaId}/porte/${porteId}`)
  },

  getProcedimentosMinificados(tabelaId, porteId, search): any {
    let url = `/calculadora/procedimentosminificado/tabela/${tabelaId}/porte/${porteId}`

    if (search) url += `?search=${search}`
    else url += `?totalItems=100`

    return api.get(url)
  }
}
